import {
    AddressDto,
    CartApi,
    CheckoutDto,
    CouponDto,
    CreateClientSecretDto,
    QuantityDto,
} from '@/api';
import { apiConfiguration } from '@/api/config';

export const cartApi = new CartApi(apiConfiguration);

export const getCurrentCartQueryFn = async (calculate?: boolean, options?: RequestInit) =>
    cartApi.cartControllerGetCart(calculate, options).then((cart) => cart || null);

export const addToCartMutationFn = async ({
    quantity,
    itemId,
    calculate
}: {
    quantity: QuantityDto;
    itemId: string;
    calculate?: boolean;
}) => cartApi.cartControllerAddToCart(quantity, itemId, calculate);

export const removeFromCartMutationFn = async ({ itemId, calculate }: { itemId: string, calculate?: boolean }) =>
    cartApi.cartControllerRemoveFromCart(itemId, calculate);

export const getCartMayAlsoLikeQueryFn = async () =>
    cartApi.cartControllerGetSuggestedItem().then((cart) => cart || null);

export const getClientSecretForStripeQueryFn = async (
    body: CreateClientSecretDto
) => {
    return cartApi.cartControllerClientSecret(body);
};

export const updateCartShippingAddressMutationFn = async (body: AddressDto) => {
    return cartApi.cartControllerSetShippingAddress(body);
};

export const checkoutBuyItemMutationFn = async (body: CheckoutDto) => {
    return cartApi.cartControllerBuyItem(body);
};

export const checkoutGetEstimateMutationFn = async (
    body: CreateClientSecretDto
) => {
    return cartApi.cartControllerClientSecret(body);
};

export const submitPromoCodeMutationFn = async (body: CouponDto) => {
    return cartApi.cartControllerApplyCoupon(body);
};
export const removePromoCodeMutationFn = async (body: CouponDto) => {
    return cartApi.cartControllerRemoveCoupon(body);
};
